/* eslint-disable no-unused-vars */
export enum ErrorMessages {
    WRONG_PASSWORD = 'WRONG_PASSWORD',
    USER_NOT_FOUND = 'USER_NOT_FOUND',
    INVALID_EMAIL = 'INVALID_EMAIL',
    PASSWORDS_NOT_MATCH = 'PASSWORDS_NOT_MATCH',
    CHANGE_PASSWORD_FAILED = 'CHANGE_PASSWORD_FAILED',
    UNKNOWN_ERROR = 'UNKNOWN_ERROR',
    COVERAGE_DISTANCE_MUST_BE_A_NUMBER = 'COVERAGE_DISTANCE_MUST_BE_A_NUMBER',
    RESET_PASSWORD_LINK_SENT_TO_EMAIL = 'RESET_PASSWORD_LINK_SENT_TO_EMAIL',
    RESET_PASSWORD_TOKEN_NOT_VALID = 'RESET_PASSWORD_TOKEN_NOT_VALID',
    DRIVER_ALREADY_EXISTS = 'DRIVER_ALREADY_EXISTS',
}
